import {
	makeSlave, initColorSelect, doAjax, updateTableValue, initStitchesBackgroundColorListeners, initRedPointLogic, fakeSelected, changeStitchBackgroundColor
} from './helper'
import { loadAlreadyCustomizedOptions, replaceImage } from './interior-general-logic'

const initInteriorFC1Customizing = () => {
	initColorSelect()
	loadAlreadyCustomizedOptions()
	const setFC1 = (aeo['configuration']['FC1_A5'] === true || aeo['configuration']['FC1_A6_C9'] === true);


	if (setFC1) {
		//Interior Components Map (KEY = LEATHER, VALUE = STITCH)
		let interiorComponents = {
			centerArmrest: 'stitchCenterArmrest',
		}

		for (const key in interiorComponents) {
			if (Object.hasOwnProperty.call(interiorComponents, key)) {
				const leatherComponent = key
				const stitchComponent = interiorComponents[leatherComponent];
				const leatherComponentMatchingDotId = getDotIdWithComponent(leatherComponent)
				//load stitching component logic
				if (stitchComponent != '') {
					const stitchComponentMatchingDotId = getDotIdWithComponent(stitchComponent)
					makeSlave(leatherComponentMatchingDotId, stitchComponentMatchingDotId, stitchComponent, areMasterAndSlaveDefault, setImage)
					var material = 'leather'
					if ((stitchComponent == 'stitchDoorTrimInsert') || (stitchComponent == 'stitchCenterArmrest')) {
						material = 'alcantara'
					}
					initStitchesBackgroundColorListeners(leatherComponentMatchingDotId, stitchComponentMatchingDotId, material)
					initRedPointLogic(stitchComponent, stitchComponentMatchingDotId, setImage)
				}
				//load leather component logic
				initRedPointLogic(leatherComponent, leatherComponentMatchingDotId, setImage)
			}
		}
	}

	const set0UBQ7Q9 = aeo['configuration']['0UB_Q7Q9'] === true;
	if (set0UBQ7Q9) {
		// Q7/Q9 G8: nur Türverkleidungseinsatz, keine Naht-Kopplung
		initRedPointLogic('doorTrimInsert', getDotIdWithComponent('doorTrimInsert'), setImage)
	}
}

/**Returns the DOT ID for the component on params */
function getDotIdWithComponent(component) {
	switch (component) {
		case 'centerArmrest': return 'dot_mittelarmlehne'
		case 'doorTrimInsert': return 'dot_tuerverkleidung'
		case 'stitchDoorTrimInsert': return 'dot_tuer-kontrastnaht'
		case 'topCenterConsole': return 'dot_mittelkonsole-oben'
		case 'bottomCenterConsole': return 'dot_mittelkonsole-unten'
		case 'stitchbottomCenterConsole': return 'dot_mittelkonsole-unten-kontrastnaht'
		case 'doorArmRest': return 'dot_tuerarmauflage'
		case 'stitchDoorArmRest': return 'dot_tuerarmauflage-kontrastnaht'
		case 'stitchCenterArmrest': return 'dot_mittelarmlehne-kontrastnaht'
		case 'instrumentPanelCover': return 'dot_instru-abdeck'
		case 'stitchInstrumentPanelCover': return 'dot_naht-instru-abdeck'
		case 'stitchSoftwrap': return 'dot_softwrap-kontrastnaht'
		case 'softwrap': return 'dot_softwrap'
		default: break;
	}
}

/** Condition for makeSlave function to work */
function areMasterAndSlaveDefault(masterDotID, slaveDotID) {

	let res = false;
	const masterTileSelectedValue = document.querySelector('#' + masterDotID + ' .color.selected input')?.value
	const slaveTileSelectedValue = document.querySelector('#' + slaveDotID + ' .color.selected input')?.value
	// Tiefschwarz (214) nicht auf Kontrastnaht übertragen, da nicht verfügbar
	if (masterTileSelectedValue == 214) {
		return false;
	}
	if (masterTileSelectedValue != null && masterTileSelectedValue == aeo['default_color'] && slaveTileSelectedValue == aeo['default_color']) {
		res = true;
	}
	return res;
}

function setStitchColorPrimSec(component, colorCode) {
	setImage(component, colorCode)
	fakeSelected(getDotIdWithComponent(component), colorCode)
}

function setImage(component, colorCode) {
	const n1v = document.querySelector("input[name=n1v]").value

	if (component == 'centerArmrest' && colorCode != 214
		&& (document.querySelector('#centerArmrest td[color-code]').getAttribute('color-code') == document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code')
			|| document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code') == 99 || document.querySelector('#stitchCenterArmrest td[color-code]').getAttribute('color-code') == 199)) {
		setStitchColorPrimSec('stitchCenterArmrest', colorCode)
	}

	let imageSourceFront;
	let imageSourceBack;
	var frontSeatModel = document.querySelector("input[name=frontseatmodel]").value
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value
	const seatComponentSelection = document.querySelector("input[name=seatcomponentselection]").value
	const modelcategory = document.querySelector("input[name=modelcategory]").value

	imageSourceFront = aeo['paths']['car_frontseat_' + frontSeatModel][colorCode] + aeo['components']['interior_screen_front' + seatComponentSelection][component]
	imageSourceBack = aeo['paths']['car_backseat_' + frontSeatModel + '_' + backSeatModel][colorCode] + aeo['components']['interior_screen_back' + seatComponentSelection][component]

	// Q7/Q9 G8: doorTrimInsert nutzt eigene Bild-Keys (tve_oben statt tuerspiegel)
	if (aeo['configuration']['0UB_Q7Q9'] === true && component === 'doorTrimInsert') {
		imageSourceFront = aeo['images']['car_frontseat_' + frontSeatModel + '_0UB_Q7Q9_' + component + '_front_view'][colorCode]
		imageSourceBack = aeo['images']['car_backseat_' + backSeatModel + '_0UB_Q7Q9_' + component + '_back_view'][colorCode]
		if ((document.querySelector("input[name=carmodel]").value == 118) || (document.querySelector("input[name=carmodel]").value == 119) || (document.querySelector("input[name=carmodel]").value == 120)) {
				imageSourceBack = aeo['images']['car_backseat_' + backSeatModel + '_0UB_Q9_' + component + '_back_view'][colorCode]
			}
	}


	var componentEmboss = "footmatEmbossing";
	if (modelcategory == 'e-tron_gt') {
		if (isetronWheelCheck) replaceImage(imageSourceEmbossing, componentEmboss + 'Color', 'car_frontseat')
	}

	replaceImage(imageSourceFront, component + 'Color', 'car_frontseat')
	switch (modelcategory) {
		case 'e-tron_gt':
			if (component != 'topCenterConsole') {
				replaceImage(imageSourceBack, component + 'Color', 'car_backseat')
			}
			break;
		default:
			if ((component == 'doorTrimInsert') || (component == 'doorArmRest') || (component == 'stitchDoorArmRest')) {
				replaceImage(imageSourceBack, component + 'Color', 'car_backseat')
			}
			if (((component != 'centerArmrest') || (component != 'stitchCenterArmrest')) && (modelcategory == 'a8')) {
				replaceImage(imageSourceBack, component + 'Color', 'car_backseat')
			}
	}


	updateTableValue(component, colorCode, 'interior-components')
	doAjax({
		'interior_component': component,
		'color': colorCode,
		'src': imageSourceFront
	})
}


export { initInteriorFC1Customizing };